import {
  FDBodyText, FDHeadlineText, FDPaper, FDStack,
} from '@facet-wealth/design';
import React from 'react';
import PropTypes from 'prop-types';

const InfoBox = ({ title, description }) => {
  if (!title && !description) return null;
  return (
    <FDPaper outlined color={'info'}>
      <FDStack direction={'column'} spacing={1} paddingY={2} paddingX={4}>
        {title && <FDHeadlineText value={title} />}
        {description && <FDBodyText size={'sm'} value={description} />}
      </FDStack>
    </FDPaper>
  );
};

InfoBox.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
};

export { InfoBox };
